module.exports = __webpack_public_path__ + "img/9791195189328.c14039fe.jpg";